// extracted by mini-css-extract-plugin
module.exports = {"secondaryText":"SecondaryText_secondaryText__W6hxO","flush":"SecondaryText_flush__iSYnM"};